<template>
  <div ref="annotateContainer" id="annotate">
    <annotate-tools
      :selected-color="selectedColor"
      :selected-thickness="selectedThickness"
      :selected-font-size="selectedFontSize"
      :selected-tool="selectedTool"
      :outline-text="outlineText"
      :uploading="uploading"
      :free-user="freeUser"
      >
    </annotate-tools>
    <annotate-canvas
      :selected-color="selectedColor"
      :selected-thickness="selectedThickness"
      :selected-font-size="selectedFontSize"
      :selected-tool="selectedTool"
      :outline-text="outlineText"
      >
    ></annotate-canvas>
  </div>
</template>

<script>
import track from '@/src/tracking';
import AnnotateTools from './annotate_tools';
import AnnotateCanvas from './annotate_canvas';
import EventBus from '../event_bus';


export default {
  data: function () {
    return {
      routes: require("routes.js.erb"),
      imageUrl: this.$parent.item.links.content_url,
      freeUser: this.$parent.item.relationships.organization.meta.free,
      selectedColor: localStorage.getItem("annotate:selectedColor") || "#FF6191",
      selectedTool: localStorage.getItem("annotate:selectedTool") || "arrow",
      selectedThickness: Math.floor(localStorage.getItem("annotate:selectedThickness")) || 4,
      selectedFontSize: Math.floor(localStorage.getItem("annotate:selectedFontSize")) || 20,
      outlineText: true,
      uploading: false,
    }
  },
  mounted(){
    let vm = this;
    EventBus.$on('update:annotateCustomColor', (color) => vm.selectedColor = color)
    EventBus.$on('annotate:selectColor', (color) => vm.selectedColor = color)
    EventBus.$on('annotate:selectThickness', (thickness) => vm.selectedThickness = thickness)
    EventBus.$on('annotate:selectFontSize', (fontSize) => vm.selectedFontSize = fontSize)
    EventBus.$on('annotate:selectTool', (tool) => vm.selectedTool = tool)
    EventBus.$on('annotate:outlineText', (outlineText) => vm.outlineText = outlineText)
    EventBus.$on('annotate:upload', () => vm.uploading = true)
    EventBus.$on('annotate:cancel', () => vm.uploading = false)
    EventBus.$on('annotate:close', vm.resetTools)
    vm.$refs.annotateContainer.addEventListener("wheel", function(e){
      if (event.ctrlKey) { e.preventDefault(); }
    })
    vm.trackAnnotateOpen();
  },
  components: { AnnotateTools, AnnotateCanvas },
  methods: {
    trackAnnotateOpen: function(){
      const properties = {
        item_id: this.$route.params.slug,
        user_agent: window.navigator.userAgent
      }
      track('web_annotation_viewed', properties)
    },
    resetTools: function(){
      // as we're using <keep-alive> to prevent image from downloading everytime, we need to reset state
      const vm = this;
      vm.selectedTool = "arrow"
      vm.selectedColor = "#FF6191"
      vm.selectedThickness = 4
      vm.selectedFontSize = 40
      vm.outlineText = true
    }
  }
}
</script>

<style scoped>
  p {
    font-size: 2em;
    text-align: center;
  }

  #annotate {
    display: flex;
    height: 100vh;
    max-height: 100vh;
    flex-direction: column;
  }
</style>
